<div class="access-denied-container">
  <div class="access-denied-content">
    <div class="icon-wrapper">
      <mat-icon
        class="access-denied-icon"
        aria-hidden="true"
        >lock</mat-icon
      >
    </div>

    <h1 class="access-denied-title">Access Denied</h1>

    <p class="access-denied-description">
      You do not have permission to view this application or route with your current organization
      account.
    </p>

    <p class="access-denied-description">
      Please return to the login page to sign in with an authorized account or refresh if your
      permissions were recently updated.
    </p>

    <div class="actions">
      <button
        matButton="filled"
        color="primary"
        (click)="goToLogin()">
        Return to Login
      </button>

      <button
        matButton="outlined"
        (click)="refreshPage()">
        Refresh
      </button>
    </div>
  </div>
</div>
